export const base64Encode = (str: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(str)

  let binaryString = ''
  for (const byte of data) {
    binaryString += String.fromCharCode(byte)
  }

  return btoa(binaryString)
}

export const base64Decode = (base64Str: string) => {
  const byteString = atob(base64Str)

  const bytes = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i)
  }

  return new TextDecoder().decode(bytes)
}